import { RefObject, useEffect, useState } from 'react'

import { throttle } from 'lodash'

type Props = {
  ref: RefObject<HTMLElement>
}

export const useSticky = ({ ref }: Props): string[] => {
  const [transform, setTransform] = useState<string>('')
  // const [position, setPosition] = useState<Position | null>(null)

  const getTransform = () => {
    const { scrollY } = window
    const element = ref.current
    if (!element) {
      return
    }

    let _transform = ''
    const headerHeight = 72

    const bottom = element?.offsetTop + element?.offsetHeight
    const top = element?.offsetTop
    const height = (element.firstChild as HTMLElement)?.offsetHeight
    if (scrollY > bottom - height - headerHeight) {
      _transform = `translateY(${bottom - top - height}px)`
    } else if (scrollY > top) {
      _transform = `translateY(${scrollY - (top - headerHeight)}px)`
    }
    if (_transform !== transform) {
      setTransform(_transform)
    }
  }

  useEffect(() => {
    const handleScroll = throttle(() => getTransform(), 30)

    document.addEventListener('scroll', handleScroll)

    return () => document.removeEventListener('scroll', handleScroll)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transform])

  return [transform]
}
